import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React from "react";

type Props = {
  anchorEl: HTMLElement | null; // Button element to anchor menu to
  years: number[];
  onYearSelected: (year: number) => void;
  onClose: () => void;
};

/**
 * Year selector menu component for "Download All" functionality.
 * Displays available years as menu items, anchored to the download button.
 * Follows Material-UI Basic Menu pattern.
 */
export const YearSelectorMenu: React.FC<Props> = ({
  anchorEl,
  years,
  onYearSelected,
  onClose,
}) => {
  const open = Boolean(anchorEl);

  const handleYearClick = (year: number) => {
    onYearSelected(year);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      MenuListProps={{
        "aria-labelledby": "year-selector-button",
      }}
      slotProps={{
        paper: {
          sx: {
            width: 152,
          },
        },
      }}
    >
      {years.map(year => (
        <MenuItem
          key={year}
          onClick={() => handleYearClick(year)}
          sx={{ justifyContent: "center" }}
        >
          {year}
        </MenuItem>
      ))}
    </Menu>
  );
};
